import React, { useState } from "react";
import "../../style/feedback.css";
import { Rating } from "react-simple-star-rating";
import axios from "axios";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import logo from "./../../images/logo - Copy.png";

const FeedbackForm = () => {
  const { id } = useParams();

  const [formData, setFormData] = useState({
    driverRating: 0,
    comfortRating: 0,
    driverFeedback: "",
    comfortFeedback: "",
    id: id,
  });

  const DriverRattingF = (rate) => {
    setFormData({
      ...formData,
      driverRating: rate,
    });
  };
  const ComfortRattingF = (rate) => {
    setFormData({
      ...formData,
      comfortRating: rate,
    });
  };

  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(formData);
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/tripclosure/FeedBack`,
          formData,{
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem(
                "access_token"
              )}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
        })
        .catch((err) => {
          FailedMSG(err);
        });
    } catch (e) {
      console.error(e);
    }
  };
  //
  return (
    <>
      <img className="FeedbackLogo" src={logo} alt=""></img>
      <div className="feedback-container">
        <ToastContainer />
        <form className="feedback-form" onSubmit={handleSubmit}>
          <h2 className="feedback-title">Customer Feedback</h2>

          <div className="feedback-rate">
            <div className="feedback-field">
              <label htmlFor="driverRating" className="feedback-label">
                Driver Rating
              </label>
              <Rating
                size={30}
                initialValue={0}
                emptyColor="white"
                onClick={DriverRattingF}
              ></Rating>
            </div>
            <div className="feedback-field">
              <label htmlFor="comfortRating" className="feedback-label">
                Comfort Rating
              </label>
              <Rating
                size={30}
                initialValue={0}
                emptyColor="white"
                onClick={ComfortRattingF}
              ></Rating>
            </div>
          </div>

          <div className="feedback-field">
            <label htmlFor="driverFeedback" className="feedback-label">
              Driver Feedback
            </label>
            <textarea
              id="driverFeedback"
              name="driverFeedback"
              className="feedback-textarea"
              value={formData.driverFeedback}
              onChange={handleChange}
            />
          </div>

          <div className="feedback-field">
            <label htmlFor="comfortFeedback" className="feedback-label">
              Comfort Feedback
            </label>
            <textarea
              id="comfortFeedback"
              name="comfortFeedback"
              className="feedback-textarea"
              value={formData.comfortFeedback}
              onChange={handleChange}
            />
          </div>

          <button type="submit" className="feedback-submit-btn">
            Submit Feedback
          </button>
        </form>
      </div>
    </>
  );
};

export default FeedbackForm;
